export const permissionMixin = {
  data() {
    return {
      userPermissions: new Set(),
    };
  },

  created() {
    this.loadUserPermissions();
  },

  methods: {
    loadUserPermissions() {
      try {
        const storedPermissions = localStorage.getItem('listFeature');

        if (!storedPermissions) {
          this.userPermissions = new Set();
          return;
        }

        const permissions = storedPermissions
          .split(',')
          .map((permission) => permission.trim())
          .filter(Boolean);

        this.userPermissions = new Set(permissions);
      } catch (error) {
        console.error(
          'Error loading user permissions from localStorage:',
          error,
        );
        this.userPermissions = new Set();
      }
    },

    /**
     * Kiểm tra người dùng có quyền cụ thể không
     * @param {string} requiredPermission - Quyền cần kiểm tra
     * @returns {boolean}
     */
    hasPermission(requiredPermission) {
      if (!requiredPermission || typeof requiredPermission !== 'string') {
        return false;
      }

      const permission = requiredPermission.trim();
      if (!permission) {
        return false;
      }

      return this.userPermissions.has(permission);
    },

    /**
     * Kiểm tra người dùng có ít nhất 1 trong các quyền (logic OR)
     * @param {string[]} requiredPermissions - Danh sách quyền cần kiểm tra
     * @returns {boolean}
     */
    hasAnyOfPermissions(requiredPermissions) {
      if (!Array.isArray(requiredPermissions)) {
        return false;
      }

      if (requiredPermissions.length === 0) {
        return true;
      }

      return requiredPermissions.some((permission) =>
        this.hasPermission(permission),
      );
    },

    /**
     * Kiểm tra người dùng có tất cả các quyền (logic AND)
     * @param {string[]} requiredPermissions - Danh sách quyền cần kiểm tra
     * @returns {boolean}
     */
    hasAllPermissions(requiredPermissions) {
      if (!Array.isArray(requiredPermissions)) {
        return false;
      }

      if (requiredPermissions.length === 0) {
        return true;
      }

      return requiredPermissions.every((permission) =>
        this.hasPermission(permission),
      );
    },

    /**
     * Kiểm tra nhóm quyền
     * @param {Object} permissionGroup - Đối tượng chứa các điều kiện quyề
     * @param {string[]} permissionGroup.any - Có ít nhất 1 quyền trong danh sách này
     * @param {string[]} permissionGroup.all - Phải có tất cả quyền trong danh sách này
     * @returns {boolean}
     *
     * Ví dụ: checkPermissionGroup({ any: ['admin', 'manager'], all: ['read_reports'] })
     */
    checkPermissionGroup(permissionGroup) {
      if (!permissionGroup || typeof permissionGroup !== 'object') {
        return false;
      }

      const { any = [], all = [] } = permissionGroup;

      const hasRequiredAny = any.length === 0 || this.hasAnyOfPermissions(any);
      const hasRequiredAll = all.length === 0 || this.hasAllPermissions(all);

      return hasRequiredAny && hasRequiredAll;
    },
  },
};
